<template>
  <el-dialog
    class="rightDetailModal shopRightDetail"
    :visible.sync="modalInfo.isShow"
    v-if="modalInfo.isShow"
    width="40%"
  >
    <div slot="title" class="shop-header">
      <h3 class="shop-name">
        {{modalInfo.detail.shopName||modalInfo.detail.shop_name}}
        <img
          v-if="modalInfo.detail.platform_code"
          :src="require('@/assets/img/platform/pla_'+modalInfo.detail.platform_code+'.png')"
          alt
          class="edit_icon"
        />

        <span>{{modalInfo.detail.wangwang}}</span>
      </h3>
    </div>
    <el-tabs v-model="activeName" v-loading="loading">
      <el-tab-pane label="店铺档案" name="1" class="tabs-grey tabs-basic" v-if="!isEdit">
        <div style="background-color: white;padding: 20px;margin-bottom: 20px;border-radius: 16px;">
          <p>
            <span class="label">平台:</span>
            {{modalInfo.detail.platformname}}
          </p>
          <p>
            <span class="label">店铺名称:</span>
            {{modalInfo.detail.shopName ||modalInfo.detail.shop_name ||'--'}}
          </p>
          <p>
            <span class="label">店铺首页地址:</span>
            <el-link
            :underline="false"
              type="primary"
              :href="modalInfo.detail.shopUrl||modalInfo.detail.shop_url||''"
              target="_blank"
            >{{modalInfo.detail.shopUrl || modalInfo.detail.shop_url ||'--'}}</el-link>
          </p>
          <p>
            <span class="label">旺旺(仅淘系):</span>
            {{modalInfo.detail.wangwang||'--'}}
          </p>
          <p>
            <span class="label">开店经销商:</span>
            {{modalInfo.detail.dealername||'--'}}
          </p>
          <p>
            <span class="label">供货经销商:</span>
            {{modalInfo.detail.supplydealername||'--'}}
          </p>
          <p>
            <span class="label">业务人员:</span>
            {{modalInfo.detail.businesspeople||'--'}}
          </p>
          <p>
            <span class="label">业务人员联系方式:</span>
            {{modalInfo.detail.businesspeoplecontact||'--'}}
          </p>
          <p>
            <span class="label">店铺运营负责人:</span>
            {{modalInfo.detail.shopoperate||'--'}}
          </p>
          <p>
            <span class="label">店铺运营联系方式:</span>
            {{modalInfo.detail.shopoperatecontact||'--'}}
          </p>
          <p>
            <span class="label">经销商负责人:</span>
            {{modalInfo.detail.dealeroperate||'--'}}
          </p>
          <p>
            <span class="label">经销商联系方式:</span>
            {{modalInfo.detail.dealeroperatecontact||'--'}}
          </p>
          <p>
            <span class="label">备注:</span>
            {{modalInfo.detail.remark||'--'}}
          </p>
          <p>
            <span class="label">营业执照地址:</span>
            {{ modalInfo.detail.province }}{{ modalInfo.detail.city }}{{ modalInfo.detail.district }}{{ modalInfo.detail.businesslicenseaddress }}
          </p>
          <p>
            <span class="label">公司名称:</span>
            {{modalInfo.detail.companyname||'--'}}
          </p>
          <el-button @click="editHandle" type="primary" size="small" style="margin-left: 122px;" v-if="type.editStatus">编辑</el-button>
        </div>
      </el-tab-pane>
      <el-tab-pane label="店铺档案" name="1" class="tabs-grey tabs-basic" v-if="isEdit">
        <xinmingm
          :modalInfo="editModalInfo"
          @showEdit="showEdit"
          @reqDetail="reqDetail"
          @reqTableData="$emit('reqTableData')"
        />
      </el-tab-pane>
      <el-tab-pane label="违规记录" name="2">
        <lowPriceRecord :lowpriceData="modalInfo.detail" />
      </el-tab-pane>
    </el-tabs>
  </el-dialog>
</template>
<script>
import xinmingm from "../xinmingm"; //编辑
import lowPriceRecord from "@/components/lowPriceRecord";
import { fetchGet, fetchPost } from "@/libs/reqCommon";
export default {
  name: "detailModel",
  components: { xinmingm, lowPriceRecord },
  props: {
    modalInfo: {
      type: Object,
      default: () => {}
    },
    editModalInfo: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      loading: true,
      activeName: "1",
      isEdit: false,
      type: {}
    };
  },
  created() {
    // this.getRecentDate();
  },
  mounted() {
    this.type = JSON.parse(window.localStorage.userData)
    console.log(this.type.logintype)
  },
  computed: {
    platformImg() {
      let img = "";
      try {
        img = require("@/assets/img/platform/pla_" +
          this.modalInfo.detail.platform_code +
          ".png");
      } catch (err) {
        img = "";
      }
      return img;
    }
  },
  methods: {
    showEdit(isShow) {
      this.isEdit = isShow;
    },
    editHandle() {
      this.isEdit = true;
      let payload = {
        index: null,
        row: this.modalInfo.row
      };
      this.$emit("editClick", payload);
    },
    reqDetail(payload) {
      this.$emit("reqDetail", payload);
    }
  }
};
</script>
<style lang="scss">
@import "src/style/shopDetail";
.tabs-grey {
  p .label {
    width: 166px !important;
  }
}
</style>
